// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__1_vUd","rootCenter":"LoadMoreObserver_rootCenter__pU5CH","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__2y9tm"};